import { useIsModuleEnabled } from '../hooks/useConfigVisibility';

interface MapLinkButtonProps {
  to: string;
  label?: string;
  className?: string;
}

export default function MapLinkButton({ to, label = 'Auf Karte', className = '' }: MapLinkButtonProps) {
  // The map is a feature-gated page; hide the shortcut when it's disabled.
  if (!useIsModuleEnabled('karte')) return null;
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-teal-100 text-teal-800 hover:bg-teal-200 transition-colors ${className}`}
    >
      <span aria-hidden="true">📍</span>
      {label}
    </a>
  );
}
